import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const NAV_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'Courses', path: '/courses' },
  { label: 'Syllabus', path: '/syllabus' },
  { label: 'Fees', path: '/fees' },
  { label: 'About', path: '/about' },
  { label: 'Careers', path: '/careers' },
  { label: 'Contact', path: '/contact' },
];

const styles = {
  nav: {
    position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
    background: 'rgba(27,58,107,0.97)', backdropFilter: 'blur(10px)',
    padding: '0 24px',
  },
  inner: {
    maxWidth: 1100, margin: '0 auto',
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    height: 64,
  },
  logo: {
    display: 'flex', alignItems: 'center', gap: 10,
    textDecoration: 'none',
  },
  logoText: {
    color: '#fff', fontWeight: 900, fontSize: 19,
    lineHeight: 1.4, fontFamily: 'cinzel decorative'
  },
  logoSub: {
    color: '#F0B429', fontSize: 10,
    fontWeight: 700, letterSpacing: '1.5px'
  },
  linksList: { display: 'flex', alignItems: 'center', gap: 2 },
  link: {
    color: 'rgba(255,255,255,0.82)',
    padding: '8px 12px',
    borderRadius: 8,
    fontWeight: 600,
    fontSize: 14,
    textDecoration: 'none',
  },
  linkActive: {
    color: '#fff',
    background: 'rgba(255,255,255,0.15)',
  },
  cta: {
    background: '#C41E3A',
    color: '#fff',
    padding: '9px 20px',
    borderRadius: 50,
    fontWeight: 800,
    fontSize: 14,
    border: 'none',
    cursor: 'pointer'
  },
  hamburger: {
    display: 'none',
    flexDirection: 'column',
    gap: 5,
    cursor: 'pointer',
    padding: 8,
    background: 'none',
    border: 'none',
  },
  bar: {
    width: 24,
    height: 2,
    background: '#fff',
    borderRadius: 2,
  },
};

export default function Nav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const isActive = (path) => location.pathname === path;

  return (
    <nav style={{
      ...styles.nav,
      boxShadow: scrolled ? '0 2px 20px rgba(0,0,0,0.25)' : 'none'
    }}>
      <div style={styles.inner}>

        {/* Logo */}
        <Link to="/" style={styles.logo}>
          <img src="/VRK_Logo.png" alt="VRK Tech Academy" style={{ height: 38, borderRadius: 10 }} />
          <div>
            <div style={styles.logoText}>VRK Tech Academy</div>
            <div style={styles.logoSub}>SKILL · BUILD · FUTURE</div>
          </div>
        </Link>

        {/* Desktop Links */}
        <div className="desktop-nav" style={{ display: 'flex', alignItems: 'center' }}>
          {NAV_LINKS.map(({ label, path }) => (
            <Link
              key={path}
              to={path}
              style={{
                ...styles.link,
                ...(isActive(path) ? styles.linkActive : {})
              }}
            >
              {label}
            </Link>
          ))}

          <button
            style={styles.cta}
            onClick={() => navigate('/register')}
          >
            📅 Register for Course
          </button>
        </div>

        {/* Hamburger */}
        <button
          style={styles.hamburger}
          onClick={() => setOpen(!open)}
          className="hamburger-btn"
        >
          <span style={styles.bar} />
          <span style={styles.bar} />
          <span style={styles.bar} />
        </button>
      </div>

      {/* Mobile Menu */}
      {open && (
        <div style={{
          background: '#1B3A6B',
          padding: '16px 24px',
          display: 'flex',
          flexDirection: 'column',
        }}>
          {NAV_LINKS.map(({ label, path }) => (
            <Link
              key={path}
              to={path}
              style={{
                ...styles.link,
                ...(isActive(path) ? styles.linkActive : {})
              }}
              onClick={() => setOpen(false)}
            >
              {label}
            </Link>
          ))}

          <button
            style={{ ...styles.cta, marginTop: 10 }}
            onClick={() => {
              navigate('/register');
              setOpen(false);
            }}
          >
            📅 Register for Course
          </button>
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .desktop-nav { display: none !important; }
          .hamburger-btn { display: flex !important; }
        }
        @media (min-width: 769px) {
          .hamburger-btn { display: none !important; }
        }
      `}</style>
    </nav>
  );
}
